var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapContainer"},[_c('sky-charts',{ref:"chart",attrs:{"api-conf":_vm.apiConf,"config":_vm.chartConfig,"extend":_vm.extend,"showTitle":false,"showShadow":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }